import getUrlForEnv, {services} from "@irati/utils/endpoints/getUrlForEnv"
import authentication from "@irati/auth"

const endpoints = {
  create: () => getUrlForEnv(services.MEDICAL_SERVICE, "/v1/accounts"),
  getMedicalAccount: () => getUrlForEnv(services.MEDICAL_SERVICE, `/v1/accounts/user/${authentication.user().uuid}`),
  textMeInstructions: () => getUrlForEnv(services.MEDICAL_SERVICE, "/v1/sms"),
  getStats: () => getUrlForEnv(services.MEDICAL_SERVICE, `/v1/activation/tenant/${authentication.business().uuid}/stats`),
  getCsv: (tenantId: string) => getUrlForEnv(services.MEDICAL_SERVICE, `/v1/activation/tenant/${tenantId}/csv`),
  resendWelcomeEmail: () => getUrlForEnv(services.MEDICAL_SERVICE, "/v1/resend-welcome-email")
}

export default endpoints
